import { useEffect, useState } from 'react';

import { fetchDocUploadEnabled } from 'pages/assistant/services/portfolioDocumentImport';
import activityPanelStore from 'shared/store/activityPanelStore';

/**
 * The composer paperclip (the only upload entry point) shows only when the api has the
 * upload on AND the session is in builder mode: rebalancing (and diagnosis) never
 * offer it. The mode follows the Fineco token's `feature` and the thread's own mode.
 */
export function useDocUploadAvailable(): boolean {
  const builder = activityPanelStore((state) => state.constraintsPanelMode) === 'builder';
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let mounted = true;
    void fetchDocUploadEnabled().then((on) => mounted && setEnabled(on));
    return () => {
      mounted = false;
    };
  }, []);
  return enabled && builder;
}
